import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchAllLandingpages } from 'src/api/admin-landing-pages';
import {
    FETCH_ALL_LANDINGPAGES,
    requestAllLandingpages,
    requestAllLandingpagesFailure,
    requestAllLandingpagesSuccess,
} from './actions';

/* Landingpages */
function* fetchAllLandingpagesSaga(action: AnyAction): SagaIterator {
    yield put(requestAllLandingpages());

    const { error, response } = yield call(fetchAllLandingpages, action.pageable);

    if (error) yield put(requestAllLandingpagesFailure(error));
    else yield put(requestAllLandingpagesSuccess(response));
}

export function* generateFetchAllLandingpagesWatcher() {
    yield takeLatest(FETCH_ALL_LANDINGPAGES, fetchAllLandingpagesSaga);
}
